export default {
    data() {
        return {
            // Content sections for cleaner management
            emailSections: {
                body: '',
                signature: ''
            },
            isInitializing: false
        }
    },

    computed: {
        // Generate the complete email content from sections
        completeEmailBody() {
            if (!this.emailSections.body) return ''
            
            let content = this.emailSections.body
            
            // Only add signature if it exists
            if (this.emailSections.signature) {
                // Add separator if not already in signature
                const separator = this.emailSections.signature.startsWith('<p>--</p>') ? 
                    '<p><br></p>' : '<p><br></p><p>--</p>'
                content += separator + this.emailSections.signature
            }
            
            return content
        },
        
        // For watching model changes
        modelForWatcher() {
            return _.cloneDeep(this.model)
        }
    },
    
    watch: {
        // Watch the computed property instead of direct model updates
        completeEmailBody: {
            handler(newValue) {
                if (this.isInitializing) return
                this.model.body = newValue
            }
        },
        
        // Update signatures section when signature is changed
        signatureSelected: {
            handler(newVal) {
                if (this.isInitializing) return
                this.updateSignatureSection(newVal?.body || '')
            }
        },
        
        // For model change detection
        modelForWatcher: {
            handler(newVal, oldVal) {
                if(!_.isEmpty(oldVal) && !this.$store.getters.progress && 
                   (JSON.stringify(newVal) !== JSON.stringify(this.oldVal))) {
                    this.$store.commit('setModelEdited', true)
                }
            },
            deep: true
        }
    },
    
    methods: {
        // Process an incoming template
        processTemplate(template) {
            if (!template) return
            
            // Store just the template part without signature
            this.emailSections.body = template.body || ''
        },
        
        // Update the signature section
        updateSignatureSection(signatureContent) {
            this.emailSections.signature = signatureContent || ''
        },
        
        // Initialize template and signature from server data
        initializeEmailContent(template, signature) {
            this.isInitializing = true
            
            // Make sure we have valid objects even if null/undefined is passed
            const safeTemplate = template || { body: '' }
            const safeSignature = signature || { body: '' }
            
            this.processTemplate(safeTemplate)
            this.updateSignatureSection(safeSignature.body || '')
            
            // Apply to model
            this.model.body = this.completeEmailBody
            
            setTimeout(() => {
                this.isInitializing = false
            }, 100)
        },
        
        // Set template in editor with appropriate signature handling
        setTemplateInTextEditor(event, server = false) {
            if (this.isInitializing) return
            
            if (server) {
                if (event?.value) {
                    this.axios.post('parse-template', {
                        template_id: event.value, 
                        id: this.id, 
                        model_class: this.model_name
                    }).then(response => {
                        this.processTemplate({ body: response.data.data.body })
                        // Model will be updated via computed property watcher
                    })
                }
            } else if (event?.body) {
                this.processTemplate(event)
                // Model will be updated via computed property watcher
            }
        },
        
        // Other standard methods...
        setTemplateVariable(value) {
            if (this.$refs.tinymceEditor) {
                this.$refs.tinymceEditor.insertContent('{{' + value + '}}')
                return
            }
            if (!this.$refs.editor) return
            let QuillEditor = this.$refs.editor.quill
            this.$eventBusUtility.setVaribleTexEditor(QuillEditor, value)
        },
        
        // Select default items
        selectDefaultItem(defaultId, items, defaultValue) {
            if (typeof defaultId === 'undefined') {
                return defaultValue
            }
            return items.find(item => item.value === defaultId) || defaultValue
        },
        
        // Form validation
        validateFields() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.confirmSendMail = true
                }
            })
        }
    }
}